<template>
    <v-skeleton-loader
        loading
        type="table"
        :types="{ 'table-tbody': 'table-row-divider@10', 'table-row': `table-cell@${cols}`, 'table-thead': `heading@${cols}`, 'table-heading': '', 'table-tfoot': ''}"
    />
</template>

<script>
export default {
    name: "TableLoading",
    props: {
        cols: {
            default: 10,
        }
    }
}
</script>

<style scoped>

</style>